import React, { useEffect, useState } from 'react'
import { Router, navigate } from '@reach/router'
import PrivateLayout from '../components/PrivateLayout'
import SEO from '../components/seo'
import GetCreditWorthiness from '../components/credit-worthiness/GetCreditWorthiness'
import appConfig from '../appConfig'

// TODO: Add a check for client

function CreditWorthiness() {
  const [open, setOpen] = useState(true)
  const [idNumber, setIdNumber] = useState()

  useEffect(() => {
    // Redirect if feature is disabled
    if (!appConfig.coreFeatures.creditWorthiness) {
      navigate('/')
      return
    }

    let givenIdNumber = new URLSearchParams(window.location.search).get('idNumber')
    setIdNumber(givenIdNumber)
  }, [])

  if (typeof window === "undefined") {
    return <div />
  }

  // Don't render if feature is disabled
  if (!appConfig.coreFeatures.creditWorthiness) {
    return <div />
  }

  return <PrivateLayout showSideBar={false} selectedIndex={0}>
    <SEO title="MyMeerkat Credit Worthiness Assessment" />
    <Router basepath="/credit-worthiness">
      <GetCreditWorthiness path="/" open={open} setOpen={setOpen} idNumber={idNumber} setIdNumber={setIdNumber} />
    </Router>
  </PrivateLayout>
}

export default CreditWorthiness